import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AccessibilityModal from "./../components/AccessibilityModal";

const Entrada1 = () => {
  const [showModal, setShowModal] = useState(false);

  // Sample news data for the sidebar
  const latestNews = [
    {
      id: 1,
      title: "Espacios de trabajo para todos: cómo la accesibilidad impulsa productividad, inclusión y bienestar",
      excerpt: "Quería comenzar este artículo con datos técnicos y aclaraciones normativas, pero luego pensé: a veces es más efectivo transmitir una idea a través de una experiencia real....",
      link: "/espacio-de-trabajo-para-todos",
    },
    {
      id: 2,
      title: "Hogar accesible, vida autónoma: la clave de viviendas inclusivas para personas mayores y con discapacidad",
      excerpt: "Diseñar viviendas accesibles no solo mejora la autonomía y calidad de vida de personas con discapacidad o adultos mayores, sino que también previene accidentes y permite que sus habitantes permanezcan en el hogar por más tiempo...",
      link: "/hogar-accesible-vida-automata",
    },
   
  ];

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <div className="micolor-jm">
      <Header />
      <button className="floating-button" onClick={toggleModal}>
        <img
          src={require("../assets/clientes/iconoaccesibilidad.jpg")}
          alt="Imagen vertical"
          className="img-vertical"
          style={{
            width: "50px",
            height: "50px",
          }}
        />
      </button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />

      <div className="container">
        <div className="row row-jm">
          {/* Main Content Column (8 units on medium screens) */}
          <div className="col-md-8 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">
              Espacios de trabajo para todos: cómo la accesibilidad impulsa
              productividad, inclusión y bienestar
            </h2>

            <img
              src={require("../assets/home/ata.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "100%",
              }}
            />
<p>Fecha: 25/05/2025</p>
            <div className="article-content">
              <p className="text-justify">
                Quería comenzar este artículo con datos técnicos y aclaraciones
                normativas, pero luego pensé: a veces es más efectivo transmitir
                una idea a través de una experiencia real. Por eso quiero
                contarles una situación que pude presenciar y que puede ser un
                buen punto de partida para entender cómo la accesibilidad puede
                influir en el rendimiento de los trabajadores.
              </p>

              <p className="text-justify">
                Hace muchos años, en uno de mis primeros empleos, tenía un
                compañero cuya labor consistía en llevar documentación y
                realizar recados dentro de la oficina. Su trabajo requería
                desplazarse constantemente entre los diferentes pisos del
                edificio, lo que implicaba subir y bajar escaleras varias veces
                al día. Recuerdo que era una edificación de cuatro pisos y no
                tenía ascensor.
              </p>

              <p className="text-justify">
                Muchos compañeros lo criticaban, diciendo que era flojo, que no
                le gustaba trabajar y que siempre buscaba excusas para quedarse
                sentado. Yo pude comprobar que, efectivamente, su desempeño
                dejaba mucho que desear y que no cumplía con la mayoría de los
                recados. Sin embargo, llevaba años en ese puesto y conocía muy
                bien la dinámica de la empresa.
              </p>

              <p className="text-justify">
                Por supuesto, los compañeros con más antigüedad lo recordaban en
                sus primeros años como alguien ágil y eficiente, siempre
                dispuesto a colaborar. Con el tiempo, la oficina fue remodelada.
                Se hicieron varias mejoras en infraestructura y, entre ellas, se
                instaló un ascensor.
              </p>

              <p className="text-justify">
                Lo que ocurrió después fue sorprendente: ese compañero comenzó a
                moverse con mucha más agilidad. Lo veíamos constantemente yendo
                de un piso a otro, sonriente, eficiente y comprometido con sus
                tareas, tal como lo hacía en sus años de juventud. Conocía al
                detalle los procesos de la oficina y los documentos llegaban a
                tiempo. Sus recados se realizaban con rapidez y precisión.
              </p>

              <p className="text-justify">
                ¿Qué había cambiado? Muy simple: ahora podía moverse sin dolor
                ni limitaciones. Resultó que tenía una lesión en la rodilla,
                producto de los años de trabajo, que dificultaba enormemente su
                movilidad. El ascensor, más allá de ser un elemento de confort,
                fue una medida de accesibilidad que transformó su experiencia
                laboral y, con ello, nos permitió redescubrir al trabajador
                eficiente y eficaz que siempre había sido.
              </p>

              <p className="text-justify">
                Este ejemplo deja en claro que, muchas veces, las medidas de
                accesibilidad en los espacios laborales se ven como un gasto
                innecesario o una obligación para cumplir con la normativa. Sin
                embargo, son mucho más que eso: representan una oportunidad
                estratégica para mejorar la productividad, la eficiencia y el
                bienestar de todos los trabajadores, no solo de quienes tienen
                una discapacidad o movilidad reducida.
              </p>

              <p className="text-justify">
                Contar con pasillos amplios, buena iluminación y ventilación,
                señalización clara, baños adaptados, lactarios, rampas,
                barandas, ascensores, planos de ubicación visibles y espacios de
                descanso y calma es beneficioso para toda la plantilla. Pensemos
                también en adultos mayores, mujeres embarazadas o personas con
                lesiones temporales: todos se ven favorecidos por un entorno
                inclusivo y accesible.
              </p>

              <p className="text-justify">
                Por ello, es fundamental realizar diagnósticos periódicos sobre
                el estado de accesibilidad en nuestros centros de trabajo y
                fomentar una cultura inclusiva. Solo así podremos construir
                espacios verdaderamente pensados para todos, donde cada persona
                pueda desarrollar su potencial sin barreras innecesarias.
              </p>
            </div>
          </div>

          {/* Sidebar Column (4 units on medium screens) */}
          <div className="col-md-4 col-sm-12 mt-5">
            <div className="sidebar-card">
              <h3 className="sidebar-title">Últimas Noticias</h3>
              <div className="news-list">
                {latestNews.map((news) => (
                  <div key={news.id} className="news-item">
                    <a href={news.link} className="news-link">
                      <h4 className="news-title">{news.title}</h4>
                      <p className="news-excerpt">{news.excerpt}</p>
                    </a>
                  </div>
                ))}
              </div>

              <div className="more-news-link">
                <a href="/noticias">
                <button className="contact-button">Ver mas noticias</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Entrada1;
